import type { AdType, Config, CreativeType } from '.';
import { creativeTypes } from '.';

interface BasePermittedCreativeTypes {
  default: Config<CreativeType>;
}

interface VastEnabledCreativeTypes extends BasePermittedCreativeTypes {
  vast: Config<CreativeType>;
  magnite: Config<CreativeType>;
}

interface DraxMagniteExtendedCreativeType extends BasePermittedCreativeTypes {
  drax: Config<CreativeType>;
  magnite: Config<CreativeType>;
}

type PermittedCreativeTypes = BasePermittedCreativeTypes | VastEnabledCreativeTypes | DraxMagniteExtendedCreativeType;

export const permittedCreativeTypes: Record<AdType, PermittedCreativeTypes> = {
  UNKNOWN: {
    default: creativeTypes.VIDEO,
  },
  AD_SELECTOR: {
    default: creativeTypes.BRIGHTLINE,
  },
  AD_SELECTOR_SLATE: {
    default: creativeTypes.AD_SELECTOR_SLATE,
  },
  AD_SELECTOR_VIDEO: {
    default: creativeTypes.AD_SELECTOR_VIDEO,
  },
  BE_SELECTOR_SLATE: {
    default: creativeTypes.SLATE,
  },
  BE_SELECTOR_VIDEO: {
    default: creativeTypes.VIDEO,
  },
  BRIGHTLINE: {
    default: creativeTypes.BRIGHTLINE,
    drax: creativeTypes.DRAX,
    magnite: creativeTypes.MAGNITE,
  },
  COLLECTION_LOGO: {
    default: creativeTypes.VIDEO,
  },
  COVER_STORY_LOGO: {
    default: creativeTypes.VIDEO,
  },
  GATEWAY_GO: {
    default: creativeTypes.GATEWAY_GO,
  },
  GATEWAY_SHOP: {
    default: creativeTypes.BRIGHTLINE,
    drax: creativeTypes.DRAX,
    magnite: creativeTypes.MAGNITE,
  },
  HUB_LOGO: {
    default: creativeTypes.VIDEO,
  },
  INNOVID: {
    default: creativeTypes.INNOVID,
  },
  MARQUEE_PROMOTED_CONTENT: {
    default: creativeTypes.VIDEO,
  },
  MAX_SELECTOR: {
    default: creativeTypes.BRIGHTLINE,
    drax: creativeTypes.DRAX,
    magnite: creativeTypes.MAGNITE,
  },
  PAUSE: {
    default: creativeTypes.PAUSE,
  },
  PAUSE_QR: {
    default: creativeTypes.PAUSE,
  },
  SLATE: {
    default: creativeTypes.SLATE,
  },
  VIDEO: {
    default: creativeTypes.VIDEO,
    vast: creativeTypes.VAST_VIDEO,
    magnite: creativeTypes.MAGNITE,
  },
  OUTSTREAM_DXC: {
    default: creativeTypes.OUTSTREAM_DXC,
  },
  INSTREAM_DXC: {
    default: creativeTypes.INSTREAM_DXC,
  },
};

export function getPermittedCreativeTypes(adTypeKey: AdType): PermittedCreativeTypes {
  return permittedCreativeTypes[adTypeKey];
}

export const EXCLUDED_SEARCH_CREATIVE_TYPES = ['MAGNITE', 'DRAX'];
